<form
  #form
  fsForm
  [submit]="save"
  *fsSkeletonForm="environmentCreate"
  [dirtySubmitButton]="false">
  <mat-card-content>
    <div class="fs-column">
      <h2>
        What diseases does your organization work with?
      </h2>
      <fs-checkbox-group
        [(ngModel)]="environmentCreate.diseases"
        name="diseases"
        label="Diseases"
        orientation="vertical">
        @for (item of diseases; track item) {
          <mat-checkbox
            [value]="item">
            {{ item.name }}
          </mat-checkbox>
        }
      </fs-checkbox-group>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      class="full-width">
      Continue
    </button>
  </mat-card-actions>
</form>